import { ITitleRequestState as ITitleRequestState } from '../interfaces/ititle-request-status';

export const TITLE_REQUEST_STATE: ITitleRequestState = {
    token: '',
    apiKeyTimbrados: '',
    active: false,
    data: undefined,
    createdAt: undefined
};
